<template>
    <div class="tag-list">
        <div class="tag-list-tiny">
            <span
                v-for="(tag, i) in tags"
                :key="i"
                :title="tag.name"
                :class="{ turncate: tags.length > limitItem && i === limitItem - 1 }"
            >
                <small
                    v-if="i < limitItem"
                    class="px-2 my-05 text-sm text-white rounded-pill d-inline-block white-space-pre text-truncate"
                    :class="{ 'mr-1': i < limitItem }"
                    :style="`background-color: ${tag.color ? tag.color : '#ef0000'}; max-width: 120px;`"
                >
                    <TagIcon size="1x"></TagIcon> {{ tag.name }}
                </small>
            </span>
        </div>
        <div v-if="tags">
            <div class="tag-list-all" v-if="tags.length > limitItem">
                <span v-for="(tag, i) in tags" :title="tag.name" :key="i">
                    <small
                        class="px-2 my-05 text-sm text-white rounded-pill d-inline-block white-space-pre text-truncate"
                        :class="{ 'mr-1': tags.length !== i + 1 }"
                        :style="`background-color: ${tag.color ? tag.color : '#ef0000'}; max-width: 120px;`"
                    >
                        <TagIcon size="1x"></TagIcon> {{ tag.name }}
                    </small>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { TagIcon } from 'vue-feather-icons'

export default {
    name: 'tags',

    props: {
        tags: {
            type: Array,
            default: null
        },
        limitItem: {
            type: Number,
            default: 5
        }
    },

    components: {
        TagIcon
    }
}
</script>

<style lang="scss" scoped>
.tag-list {
    width: calc(100px * 3);

    small {
        padding-top: 0.1rem;
        padding-bottom: 0.1rem;
    }

    .tag-list-tiny {
        span.turncate {
            position: relative;
            &::after {
                content: '...';
                position: absolute;
                bottom: 0rem;
                right: -0.75rem;
                font-size: 1.4em;
                color: #aaa;
            }
        }
    }

    .tag-list-all {
        position: absolute;
        top: -1rem;
        left: -1rem;
        opacity: 0;
        background-color: white;
        padding: 1rem;
        border-radius: 0.25rem;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
        pointer-events: none;
    }

    &:hover {
        position: relative;

        .tag-list-all {
            opacity: 1;
            pointer-events: all;
        }
    }
}
</style>
